import _ from 'lodash';
import Vue from 'vue';

const messages = {
	namespaced: true,
	state: {
		messages: [],
		messagesRaw: [],
		viewingMessages: [],
		messagesCount: '',
	},
	getters: {
		messages(state){
			return state.messages
		},
		messagesRaw(state){
			return state.messagesRaw
		},
		viewingMessages(state){
			return state.viewingMessages
		},
		messagesCount(state){
			return state.messagesCount
		}
	},
	mutations: {
		setMessages(state, messages){
			state.messages =  _.chain(messages).uniqBy( message => message._id.toString() ).value()
		},
		setConcatReverseMessages(state, messages){
			state.messages = state.messages.concat(messages);
		},
		setConcatMessages(state, messages){
			state.messages = state.messages.concat(messages);
		},
		setMessagesRaw(state, messages){
			state.messagesRaw =  _.chain(messages).uniqBy( message => message._id.toString() ).value()
		},
		setConcatMessagesRaw(state, messages){
			state.messagesRaw = messages.concat(state.messagesRaw);
		},
		setUpdateMessages(state, message){
			state.messages = messages.concat(state.messages);
		},
		setViewingMessages(state, viewingBy){
			state.viewingMessages = viewingBy;
		},
		setMessagesCount(state, messagesCount){
			state.messagesCount = messagesCount;
		},
		setUpdateOneViewingMessage(state, viewingBy){
			var index = _.findIndex(state.viewingMessages, {messageId: viewingBy.messageId});
			state.viewingMessages[index] = viewingBy;
			Vue.set(state.viewingMessages, index, state.viewingMessages[index]);
		},
		viewingMessagesArray(state, query){
			//CRUD Experiment
			if(query.type == 'create'){
				state.viewingMessages.push(query.data);
			}
			if(query.type == 'delete'){
				if(query.data.userId){
					state.viewingMessages = state.viewingMessages.filter(function (n) {
						return (n.messageId !== query.data.messageId || n.user._id !== query.data.userId)
					})
				}else{
					state.viewingMessages = state.viewingMessages.filter(function (n) {
						return n.messageId !== query.data.messageId
					})
				}
			}
			if(query.type == 'deleteByUserId'){
				state.viewingMessages = state.viewingMessages.filter(function (n) {
					return n.user._id !== query.data.userId
				})
			}
		}
	},
		actions: {
		setMessages({ commit }, messages){
			commit('setMessages', messages)
		},
		setConcatMessages({ commit }, messages){
			commit('setConcatMessages', messages)
		},
		setConcatReverseMessages({ commit }, messages){
			commit('setConcatReverseMessages', messages)
		},
		setMessagesRaw({ commit }, messages){
			commit('setMessagesRaw', messages)
		},
		setConcatMessagesRaw({ commit }, messages){
			commit('setConcatMessagesRaw', messages)
		},
		setUpdateOneMessage({ commit }, viewingBy){
			commit('setUpdateOneMessage', viewingBy)
		},
		setViewingMessages({ commit }, viewingBy){
			commit('setViewingMessages', viewingBy)
		},
		viewingMessagesArray({ commit }, query){
			commit('viewingMessagesArray', query)
		},
		setMessagesCount({ commit }, messagesCount){
			commit('setMessagesCount', messagesCount)
		}
	}
}

export default messages;


// WEBPACK FOOTER //
// ./src/store/messages.js